import { BaseService } from './baseService';

class GroupsService extends BaseService<Group, 'groupID', 'groups'> {
	constructor() {
		super('groupID', 'group', 'groups');
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new GroupsService();
